import { i18n } from '@lingui/core'

export { i18n }
export default i18n
